// All the events

export const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
  CODE_CHANGE: "code-change",
  SYNC_CODE: "sync-code",
  LEAVE: "leave",
  SEND_MESSAGE: "send-message",
  RECEIVE_MESSAGE: "receive-message",
  USER_ONLINE: "user-online",
  USER_OFFLINE: "user-offline",
  ONLINE_USERS_UPDATE: "online-users-update",
  SYNC_REQUEST: "sync-request",
  FILE_CREATED: "file-created",
  FILE_UPDATED: "file-updated",
  FILE_RENAMED: "file-renamed",
  FILE_DELETED: "file-deleted",
  RTC_OFFER: "rtc-offer",
  RTC_ANSWER: "rtc-answer",
  RTC_ICE_CANDIDATE: "rtc-ice-candidate",
  MUTE_STATUS_CHANGE: "mute-status-change",
};
